// Returns whether the value provided is "not falsy" including "0"
// which the API sometimes uses to mean false.
export default function apiTruthy(value: unknown): boolean {
    if (typeof value === 'string') {
        return value !== '' && value !== '0' && value !== 'false' && value !== 'no';
    } else {
        return !!value;
    }
}

export function yesNoConvert(value?: boolean | null): string {
    if (value !== null && value !== undefined) {
        return value ? 'yes' : 'no';
    } else {
        return '';
    }
}
